//
// csv-parse.js - quick 'n dirty csv parser
//


// parse
// ---------------------------

function parse(s, remove_header_heuristically) {
  let rows = s
    .split(/[\r\n]+/)
    .map((l) => l.split(','));

  if (remove_header_heuristically) {
    rows = remove_header(rows);
  }
  return rows;
}


// remove_header
// ---------------------------
// - if the proportion of numerical fields in the first row is much less than
//   the average proportion of numerical fields in the table, remove the first row

const k = 0.25;   // Incidence of numericals in header must be <k times their average incidence
function remove_header(rows) {
  if (rows.length < 2) {
    return rows;
  }

  let rows_without_header = rows.slice(1);
  let all_fields = [].concat.apply([], rows);

  let frac_numerical_rows__overall = n_items_that_are_numerical(all_fields) / all_fields.length;
  let frac_numerical_rows__header  = n_items_that_are_numerical(rows[0]) / rows[0].length;

  if (frac_numerical_rows__header / frac_numerical_rows__overall < k) {
    return rows_without_header;
  }
  return rows;
}

function n_items_that_are_numerical(items) {
  return items.filter((item) => !isNaN(item)).length;
}


module.exports = parse;
